<template lang="html">
  <div class="atlas-map">
    <LMap
      height="100%"
      ref="map"
      :zoom="14"
      :style="bg"
      :options="{ zoomControl: false }"
      @moveend="getMapState"
      @ready="getMapState">
      <LTileLayer
        :url="map.voyager.url"
        :options="map.voyager.opts" />

      <LCircleMarker
         v-if="user"
        :latlng="user"
        :options="{
          color: '#2196f3',
          radius: 5,
          weight: 0,
          fillOpacity: .5
        }" />

      <LMarkerClusterGroup
        :options="{ showCoverageOnHover: false }">
        <LMarker
          v-for="poi in pois"
          :key="poi._id"
          :latlng="[poi.coords[1], poi.coords[0]]"
          @click="clickMarker">
          <LAwesomeMarker
            :options="markerOpts"/>
          <LPopup
            :options="{ autoClose: true, closeButton: false, autoPan: false }">
            <PoiPopup :poi="poi" />
          </LPopup>
        </LMarker>
      </LMarkerClusterGroup>

    </LMap>
  </div>
</template>

<script>
import * as turf from '@turf/turf'
import { mapGetters, mapActions } from 'vuex'
import PoiPopup from '@/components/modules/AtlasPois/PoiPopup'
import map from './mapOptions'
export default {
  name: 'AtlasMap',
  components: {
    PoiPopup
  },
  data () {
    return {
      map,
      markerOpts: {
        icon: 'bookmark',
        markerColor: 'lightgray',
        prefix: 'fa',
        iconColor: 'white'
      },
      pois: []
    }
  },
  computed: {
    ...mapGetters({
      setting: 'user/setting',
      position: 'map/position',
      dblive: 'db/live'
    }),
    user () {
      return this.position ? [this.position.coords.latitude, this.position.coords.longitude] : null
    },
    follow () {
      return this.setting('follow')
    },
    dark () {
      return this.setting('darkTheme')
    },
    bg () {
      const background = this.dark ? '#000' : '#FFF'
      return { background }
    },
    tiles () {
      return this.dark ? this.map.dark : this.map.light
    }
  },
  watch: {
    user (val, old) {
      if (!old) this.$refs.map.layer.flyTo(val)
      if (val && old && this.follow && val[0] !== old[0] && val[1] !== old[1]) this.$refs.map.layer.flyTo(val)
    },
    follow (val, old) {
      if (val && !old && this.user) this.$refs.map.layer.flyTo(this.user)
    }
  },
  methods: {
    ...mapActions({
      setCenter: 'map/setCenter',
      setZoom: 'map/setZoom',
      saveSetting: 'user/saveSetting'
    }),
    getMapState () {
      if (this.$refs.map && this.$refs.map.layer) {
        const center = this.$refs.map.layer.getCenter()
        const zoom = this.$refs.map.layer.getZoom()
        this.setCenter(center)
        this.setZoom(zoom)
        // if user exists, and center is 100m far from the user, then it's panned
        if (this.user && this.follow) {
          const from = turf.point([center.lng, center.lat])
          const to = turf.point([this.user[1], this.user[0]])
          const dist = turf.distance(from, to)
          if (dist > 0.1) this.saveSetting({ follow: false })
        }
      }
    },
    clickMarker (e) {
      const latlng = e.target._latlng
      this.$refs.map.layer.panTo(latlng)
    }
  },
  created () {
    this.dblive('poi', {
      selector: { title: { '$exists': true } },
      aggregate: true
    }).on('update', (update, aggregate) => {
      // console.log(update.action, update.id)
      this.pois = aggregate
    })
  }
}
</script>

<style lang="scss">
.atlas-map {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  .leaflet-control-attribution {
    opacity: .5;
    font-size: 8px;
    a {
      color: var(--f7-toolbar-link-color, var(--f7-bars-link-color, var(--f7-theme-color)));
    }
  }
}
.theme-dark .leaflet-control-attribution {
  background: rgba(black, .5);
}
</style>
